import { render, staticRenderFns } from "./childTaskDetailDlg.vue?vue&type=template&id=3c6eba1a&scoped=true"
import script from "./childTaskDetailDlg.vue?vue&type=script&lang=js"
export * from "./childTaskDetailDlg.vue?vue&type=script&lang=js"
import style0 from "./childTaskDetailDlg.vue?vue&type=style&index=0&id=3c6eba1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6eba1a",
  null
  
)

export default component.exports